import { render, staticRenderFns } from "./VueFileAgent.vue?vue&type=template&id=4afecf76&"
import script from "./VueFileAgent.vue?vue&type=script&lang=js&"
export * from "./VueFileAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports